export class SelectCountry {
  static readonly type = '[ShoppingCartBilling] Select country';
  constructor(public country: string) {}
}

export class SelectBillingAddress {
  static readonly type = '[ShoppingCartBilling] Select billing address';
  constructor(public billingAddressId: number | null) {}
}
